import EntityBase from '@/data/EntityBase';
import type { SchedulerOnboardingItems } from '@/onboarding/constants';
import { EmployeeOnboardingStatus } from '@/onboarding/constants';

type OnboardingValues = {
  openGuideItem: SchedulerOnboardingItems | undefined;
  newlyCreatedShiftId: number | undefined;
  forceGuideItem: SchedulerOnboardingItems | undefined;
  blockGuideItem: boolean;
  employeeOnboardingStatus: EmployeeOnboardingStatus | undefined;
};

export default class OnboardingState extends EntityBase<undefined, OnboardingValues>({
  openGuideItem: undefined,
  newlyCreatedShiftId: undefined,
  forceGuideItem: undefined,
  blockGuideItem: false,
  employeeOnboardingStatus: EmployeeOnboardingStatus.Idle,
}) {}
